import lapdev from '../../lapdev';

export function verifyAccount(code) {
  return lapdev.post('auth/verify', { code });
}
